module.exports = __webpack_public_path__ + "img/zoho-logo.102d69df.svg";